import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoriqueService } from 'src/app/services/historique.service';
import { Router } from '@angular/router';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { EncryptionService } from 'src/app/services/encryption.service';



@Component({
  selector: 'app-historique',
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.css']
})
export class HistoriqueComponent implements OnInit {

  dateDebut : Date = new Date();
  dateFin : Date = new Date();
  maxDate : Date = new Date();
  listeHistorique: any[] = [];

  dateFilter : Date;
  loading: boolean = true;

  user : Object = {};

  cols : any[] = [
    {field:'designation_type_ptl', header:'Type'},
    {field:'num_point_accueil', header:'Login PTL'},
    {field:'id_bon_plan', header:'ID Bon Plan'},
    {field:'id_complexite', header:'Complexité'},
    {field:'designation_action', header:'Etape'},
    {field:'statut', header:'Etat'},
    {field:'duree_action', header:'Durée (DMT)'},
    {field:'id_responsable', header:'Matricule Agent'},
    {field:'date_action', header:'Date de l\'action'},
    
  ];

  typeFilter : SelectItem[] = [
    {label : 'INITIALE', value : 'INITIALE' },
    {label : 'R', value : 'R' },
    {label : 'R1', value : 'R1' },
    {label : 'R2', value : 'R2' }
  ];

  complexteFilter : SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];

  statutFilter : SelectItem[] = [
    {label : 'OK', value : 'OK' },
    {label : 'KO', value : 'KO' },
  //  {label : '', value : ''}
  ];

  EtapeFilter : SelectItem[] = [
    {label : 'MODERATION', value : 'MODERATION' },
    {label : 'CQ', value : 'CQ' },
    {label : 'ENR. SIMPLE', value : 'ENR. SIMPLE' },
    {label : 'ENR. SIMPLE(CQ)', value : 'ENR. SIMPLE(CQ)' },
    {label : 'ENR. DOUTE (CQ)', value : 'ENR. DOUTE (CQ)' },
  ];

  historiqueFilter : any[] = [
    {label : 'Toutes les actions', value : 0},
    {label : 'Traitements', value : 1},
  ];

  historiqueUserFilter : any[] = [
    {label : 'Moi uniquement', value : 0},
    {label : 'Tout le monde', value : 1},
  ];

  canSeeAll : boolean = false; //=> Permet de savoir si l'utilisateur courant peut accéder à toutes les historiques
  selectedOption : number = 1;
  selectedUserOption : number = 1;
  fr :  any; //=> langue du calendrier

  @ViewChild('dt') table: Table;

  constructor(private historiqueService : HistoriqueService, private router : Router, private dateService : DateCalculationService, private encryptService:EncryptionService) { }

  ngOnInit(): void {

    this.loading = true;
    //this.dateDebut.setDate(this.dateDebut.getDate() - 1);
    //this.dateFin.setDate(this.dateFin.getDate() - 1);

    this.user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    console.log(this.user["droit"]);

    this.rechercherHistorique(this.dateDebut, this.dateFin);

    this.fr = this.dateService.getFrLocale();

  }


  rechercherHistorique(dateDebut : Date, dateFin : Date) {
    
    let depasse = this.dateService.checkIfPlusNDays(dateDebut, dateFin, 92);
    
    if(!depasse) {
      if(this.selectedUserOption === 1) {
        this.getHistorique(this.dateDebut, this.dateFin);
      } else {
        this.getHistoriqueByUser(this.dateDebut, this.dateFin, this.user['matricule']);
      }
    } else {
      alert("Veuillez choisir une intervalle de date moins longue");
    }
  
  }

  getHistorique(dateDebut : Date, dateFin : Date ) {
    let debut = this.dateService.getFormatedDate(dateDebut).date;
    let fin = this.dateService.getFormatedDate(dateFin).date;
    let onlyTraitement : boolean = (this.selectedOption === 0) ? false : true;
    let options = {
      dateDebut : debut,
      dateFin : fin,
      onlyTraitement : onlyTraitement
    };

    this.historiqueService.getHistorique(options).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        this.listeHistorique = value["data"];
      }

      this.loading = false;
    });
  }


  getHistoriqueByUser(dateDebut : Date, dateFin : Date, idResponsable : number) {
    let debut = this.dateService.getFormatedDate(dateDebut).date;
    let fin = this.dateService.getFormatedDate(dateFin).date;
    let onlyTraitement : boolean = (this.selectedOption === 0) ? false : true;
    
    let options = {
      dateDebut : debut,
      dateFin : fin,
      onlyTraitement : onlyTraitement,
      idResponsable : idResponsable
    };

    this.historiqueService.getHistoriqueByUser(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        this.listeHistorique = value["data"];
      }

      this.loading = false;
    });
  }

  convertToIso(seconds : number) : string {
    if (seconds === null || seconds === undefined) {
      return '';
    }
    return new Date(seconds * 1000).toISOString().substr(11,8);
  } 


  checkDuree(historique:any) {
    let dmt = this.getDmt(historique.id_complexite);

    if(historique.duree_action > dmt) {
      return "customer-badge status-unqualified";
    } else if(historique.duree_action < dmt) {
      return "customer-badge status-qualified";
    } else {
      return "customer-badge status-proposal";
    }
  }

  getDmtIso(complexite:number) {
    let dmt = this.getDmt(complexite);
    return new Date(dmt * 1000).toISOString().substr(11,8);    
  }


  getDmt(complexite:number) {

    switch(complexite) {
      case(1) : {
        return 94;
        break;
      }
      case(2) : {
        return 173;
        break;
      }
      case(3) : {
        return 302;
        break;
      }
    }

  }


  voirDetails(numHistorique){
    
    let url = "" + window.location.origin + "/details/" + numHistorique;
    this.openLinkOnNewTab(url);
  }

  /**
   * Permet d'ouvrir le lien dans un nouvel onglet
   */
  openLinkOnNewTab(link : string ){
    var url = encodeURI(link);
    window.open(url, "_blank");
  }


  onDateSelect(value){
    let date = this.dateService.getFormatedDate(value)
    this.table.filter(date.date, 'date_action', 'contains');
  }


  canSelectUsers() {
    if(parseInt(this.user['droit']) === 1 || parseInt(this.user['droit']) === 2 ) return true;
    return false;
  }

  isAdmin(){
    if(parseInt(this.user["droit"]) === 1){
      return true;
    } else{
      return false;
    }
  }


  detailsClickable(idAction) {

    if( idAction === 2 || idAction === 5 || idAction === 7 || idAction === 8 || idAction === 9 || idAction === 10) {
      return true;
    }

    return false;
  }


  getComplexite(idComplexite: number) {
    switch(idComplexite) {
      case(1) : {
        return 'FAIBLE';
        break;
      }
      case(2) : {
        return 'MOYENNE';
        break;
      }
      case(3) : {
        return 'FORTE';
        break;
      }
    }
  }

}
